<template>
  <b-form>
    <template v-if="projectId">

      <b-row>
        <b-col>
          <!-- Question -->
          <b-form-group
            :label="$t('Select Question')"
            label-for="vue-select-question"
          >
            <v-select
              id="vue-select-question"
              v-model="filter.filterQuestion"
              :options="optionQuestion"
              label="questionText"
              :placeholder="$t('Select question...')"
              @input="getSelectedQuestionsOptions"
            />
          </b-form-group>
        </b-col>
        <b-col v-if="multiOperator">
          <b-form-group
            :label="$t('Operators')"
            label-for="ops"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="d-inline-block mr-1"
              @click="addOperator('(')"
            >
              (
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="d-inline-block mr-1"
              @click="addOperator(')')"
            >
              )
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="d-inline-block mr-1"
              @click="addOperator('AND')"
            >
              AND
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="d-inline-block mr-1"
              @click="addOperator('OR')"
            >
              OR
            </b-button>
          </b-form-group>

        </b-col>
      </b-row>

      <!-- Options -->
      <b-form-group
        v-if="filter.filterQuestion && (filter.filterQuestion.questionType === 1 || filter.filterQuestion.questionType === 4)"
      >
        <div class="d-flex justify-content-between">
          <label for="vue-select-question-option">Select Options</label>
          <b-link @click="selectAll">
            <small>Select All</small>
          </b-link>
        </div>

        <v-select
          id="vue-select-question-option"
          v-model="filter.filterValues"
          :options="optionQuestionOption"
          label="optionText"
          placeholder="Select options..."
          multiple
        />
      </b-form-group>

      <!-- Open Value -->
      <b-form-group
        v-else-if="filter.filterQuestion"
        label="Enter value..."
        label-for="filterValuesText"
      >
        <v-select
          id="vue-select-question-optiontext"
          v-model="filter.filterValuesText"
          :options="optionQuestionOptionText"
          :taggable="true"
          placeholder="Select options..."
          multiple
        />
      </b-form-group>

      <b-button
        v-if="filter.filterQuestion && ((filter.filterValues && filter.filterValues.length) || (filter.filterValuesText && filter.filterValuesText.length))"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="d-inline-block mr-1 mb-2"
        @click="addFilter"
      >
        {{ $t('Add') }}
      </b-button>

    </template>

    <div v-if="filters">

      <draggable
        v-model="filters"
        class="cursor-move"
      >

        <div
          v-for="(filterItem, index) in filters"
          :key="index"
        >

          <b-card>
            <b-link
              class="mr-1"
              @click="deleteFilterItem(index)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-link>

            <template v-if="filterItem.operator">
              <b-badge
                class="mr-1"
                variant="info"
                @click="toggleAndOr(filterItem)"
              >
                {{ filterItem.operator }}
              </b-badge>
            </template>
            <template v-else>
              <b-link
                class="mr-1"
                @click="editFilterItem(filterItem, index)"
              >
                <strong>{{ filterItem.filterQuestion.questionText || filterItem.filterQuestion.questionName }} </strong>
              </b-link>
              <b-dropdown
                size="sm"
                variant="outline-primary"
                :text="filterItem.filterOperator"
                class="mr-1"
              >
                <b-dropdown-item-button @click="filterItem.filterOperator='='">
                  =
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="filterItem.filterOperator='>'">
                  &gt;
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="filterItem.filterOperator='<'">
                  &lt;
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="filterItem.filterOperator='>='">
                  &gt;=
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="filterItem.filterOperator='<='">
                  &lt;=
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="filterItem.filterOperator='<>'">
                  &lt;&gt;
                </b-dropdown-item-button>
              </b-dropdown>
              <b-badge
                v-for="(val, idx) in filterItem.filterValues"
                :key="idx"
                class="mr-1"
                variant="primary"
              >{{
                val.optionText }}</b-badge>
              <b-badge
                v-for="(val, idx) in filterItem.filterValuesText"
                :key="idx"
                class="mr-1"
                variant="primary"
              >{{ val
              }}</b-badge>
            </template>
          </b-card>

        </div>

      </draggable>

    </div>

  </b-form>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BButton, BBadge, BLink, BRow, BCol, BCard, BDropdown, BDropdownItemButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'

export default {
  components: {
    BFormGroup,
    BForm,
    BButton,
    BBadge,
    BLink,
    vSelect,
    draggable,
    BRow,
    BCol,
    BCard,
    BDropdown,
    BDropdownItemButton,
  },
  directives: {
    Ripple,
  },
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Array,
      default: null,
    },
    multiOperator: {
      type: Boolean,
      default: true,
    },
    forfilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionQuestion: [],
      optionQuestionOption: [],
      optionQuestionOptionText: [],
      // optionFilterOperators: [
      //   { value: '=', label: '=' },
      //   { value: '>', label: '>' },
      //   { value: '>=', label: '>=' },
      //   { value: '<', label: '<' },
      //   { value: '<=', label: '<=' },
      //   { value: '<>', label: '<>' },
      // ],
      filter: {
        index: -1,
        filterOperator: '=',
        filterQuestion: null,
        filterValuesText: [],
        filterValues: [],
      },
    }
  },
  computed: {
    filters: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      },
    },
  },
  watch: {
    projectId() {
      if (this.projectId) {
        this.getQuestionOptions()
      }
    },
  },
  created() {
    this.getQuestionOptions()
  },
  methods: {
    toggleAndOr(item) {
      if (item.operator === 'AND' || item.operator === 'OR') {
        if (item.operator === 'AND') {
          this.$set(item, 'operator', 'OR')
        } else {
          this.$set(item, 'operator', 'AND')
        }
      }
    },
    selectAll() {
      this.filter.filterValues = []
      this.optionQuestionOption.forEach(x => {
        this.filter.filterValues.push(x)
      })
    },
    deleteFilterItem(index) {
      this.filters.splice(index, 1)
    },
    editFilterItem(item, index) {
      this.filter = JSON.parse(JSON.stringify(item))
      this.filter.index = index
      // set question text again if not exists
      if (!this.filter.filterQuestion.questionText) {
        this.filter.filterQuestion = this.optionQuestion.find(q => q.questionName === this.filter.filterQuestion.questionName)
      }
      this.getSelectedQuestionsOptions()
    },
    addFilter() {
      if (this.filter.index > -1) {
        this.filters[this.filter.index] = this.filter
      } else {
        if (!this.filters) {
          this.filters = []
        }
        this.filters.push(this.filter)
      }
      this.filter = {
        index: -1,
        filterQuestion: null,
        filterValuesText: [],
        filterValues: [],
        filterOperator: '=',
      }
    },
    addOperator(op) {
      this.filters.push({ index: -1, operator: op })

      this.filter = {
        index: -1,
        filterQuestion: null,
        filterValuesText: [],
        filterValues: [],
        filterOperator: '=',
      }
    },
    getQuestionOptions() {
      this.filter.filterValues = []
      useJwt.axiosIns.get(`question/${this.projectId}/shortlist${this.forfilter ? 'forfilter' : ''}`).then(response => {
        this.optionQuestion = response.data // .filter(q => q.questionType === 0 || q.questionType === 2)
      })
    },
    getSelectedQuestionsOptions() {
      if (this.filter.filterQuestion.questionType === 1 || this.filter.filterQuestion.questionType === 4) {
        useJwt.axiosIns.get(`questionoption/${this.projectId}/${this.filter.filterQuestion.questionName}`).then(response => {
          this.optionQuestionOption = response.data
        })
      } else if (this.filter.filterQuestion.questionType === 0) {
        useJwt.axiosIns.get(`questionoption/${this.projectId}/${this.filter.filterQuestion.questionName}/text`).then(response => {
          this.optionQuestionOptionText = response.data
        })
      }
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
